import { Box, Typography } from '@mui/material';
import { CircleBadge } from '../ExamSessions.styled';

type PropTypes = {
  value: string | number | boolean;
};

export const AnomaliesCell = ({ value }: PropTypes) => {
  const showBadge = typeof value === 'number' && value > 0;

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <Typography component='span' variant='tableCell'>
        {value}
      </Typography>
      {showBadge && <CircleBadge>!</CircleBadge>}
    </Box>
  );
};
